// @flow
import React from 'react';

import {
  Row,
  Col,
} from 'reactstrap';

const NotFound = () => (
  <Row>
    <Col>
      <h3 className="display-2 my-5 text-center">404 page not found</h3>
    </Col>
  </Row>
);

export default NotFound;



// WEBPACK FOOTER //
// ./src/pages/NotFound.js